/* Daily Dons — ugc-carousel.js
   Auto-cycling vertical video cards (UGCCarousel.tsx): videos lazy-mount
   once the carousel nears the viewport, the active card autoplays muted
   and restarts on activation, cards cycle every 5s (paused while the
   lightbox is open), duration badges read MM:SS from metadata. */
(function () {
  'use strict';

  var CYCLE_MS = 5000;

  function init(carousel) {
    var row = carousel.querySelector('[data-ugc-row]');
    var cards = [].slice.call(carousel.querySelectorAll('[data-ugc-card]'));
    var lightboxId = carousel.getAttribute('data-ugc-lightbox');
    var lightbox = lightboxId && document.getElementById(lightboxId);
    if (!cards.length) return;

    var active = 0, entered = false, timer = null;

    function videos() {
      return cards.map(function (c) { return c.querySelector('video'); });
    }

    function mountVideos() {
      if (entered) return;
      entered = true;
      videos().forEach(function (v, i) {
        if (!v) return;
        var src = v.getAttribute('data-src');
        if (src && !v.src) v.src = src;
        v.addEventListener('loadedmetadata', function () {
          var badge = cards[i].querySelector('[data-ugc-duration]');
          if (badge && isFinite(v.duration)) {
            var sec = Math.max(0, Math.floor(v.duration));
            var mm = String(Math.floor(sec / 60)).padStart(2, '0');
            var ss = String(sec % 60).padStart(2, '0');
            badge.textContent = mm + ':' + ss;
          }
        });
      });
      activate(0);
      startCycle();
    }

    function activate(idx) {
      active = idx;
      var card = cards[idx];
      if (row && card && window.innerWidth < 1024) {
        var left = card.offsetLeft - (row.clientWidth - card.clientWidth) / 2;
        row.scrollTo({ left: left, behavior: 'smooth' });
      }
      videos().forEach(function (v, i) {
        if (!v) return;
        if (i === idx) { v.currentTime = 0; v.play && v.play().catch(function () {}); }
        else v.pause();
      });
    }

    function startCycle() {
      stopCycle();
      if (cards.length <= 1) return;
      timer = setInterval(function () {
        activate((active + 1) % cards.length);
      }, CYCLE_MS);
    }
    function stopCycle() { if (timer) { clearInterval(timer); timer = null; } }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { mountVideos(); io.disconnect(); }
      }, { rootMargin: '200px 0px' });
      io.observe(carousel);
    } else mountVideos();

    if (lightbox) {
      lightbox.addEventListener('dd:modal:open', function () {
        stopCycle();
        videos().forEach(function (v) { v && v.pause(); });
      });
      lightbox.addEventListener('dd:modal:close', function () { startCycle(); });
    }
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-ugc-carousel]:not([data-ugc-init])')
      .forEach(function (el) { el.setAttribute('data-ugc-init', '1'); init(el); });
  }
  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
